/* src/app/components/app-alert/alert.component.scss */
.alert.info {
  background-color: #17a2b8;
}
.alert.warning {
  background-color: #ffc107;
}
.alert.danger {
  background-color: #dc3545;
}
.alert.success {
  background-color: #28a745;
}
:host {
  min-width: 200px;
  z-index: 9999;
  right: 20px;
  top: 20px;
  opacity: 0.9;
  position: fixed;
}
.alert {
  opacity: 0;
  margin-bottom: 10px;
  display: flex;
  padding: 15px;
  background-color: #323232;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #fff;
  justify-content: space-between;
  animation: slideup 12s;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
@media (max-width: 500px) {
  .alert {
    right: 20px;
  }
}
.alert p {
  margin: 0;
}
.alert button {
  text-transform: uppercase;
  text-decoration: none;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.alert:hover {
  animation-play-state: paused;
}
@keyframes slideup {
  0%, 100% {
    opacity: 0;
    transform: translateY(100px);
  }
  3%, 50% {
    opacity: 1;
    transform: translateY(0);
  }
  70%, 99% {
    opacity: 0;
    transform: translateY(100px);
  }
  99%, 100% {
    display: none;
  }
}
/*# sourceMappingURL=alert.component-IJ7WQ637.css.map */
